<template>
  <div class="generate-loading">
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-inner" :style="{ width: progress + '%' }"></div>
      </div>

      <div class="progress-label" :style="{ left: progress + '%' }">
        {{ progress }}%
      </div>
    </div>
    <div class="loading-text">{{loadingText}}</div>
  </div>
</template>

<script>
export default {
  name: 'GenerateLoading',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: '预计30秒左右，请耐心等待~'
    },
    // 完整加载时间：默认30s, 注意单位为毫秒
    loadingTime: {
      type: Number,
      default: 30000,
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.startProgress()
      } else {
        this.stopProgress()
      }
    },
  },
  data() {
    return {
      progress: 0,
      timer: null,
    }
  },
  methods: {
    startProgress() {
      const firstLevel = Math.floor( this.loadingTime / 5)
      const secondLevel = Math.floor( this.loadingTime / 5 * 3)
      const thirdLevel = Math.floor( this.loadingTime / 5)
      const intervals = [
        { duration: firstLevel, targetProgress: 20 },
        { duration: secondLevel, targetProgress: 90 },
        { duration: thirdLevel, targetProgress: 99 },
      ]

      let currentProgress = 0
      let elapsedTime = 0
      let currentIntervalIndex = 0
      let startProgress = 0
      let endProgress = intervals[currentIntervalIndex].targetProgress
      const totalDuration = 140000

      this.timer = setInterval(() => {
        elapsedTime += 100

        const { duration } = intervals[currentIntervalIndex]
        if (elapsedTime > duration) {
          elapsedTime -= duration
          currentIntervalIndex++
          if (currentIntervalIndex >= intervals.length) {
            this.progress = 99
            clearInterval(this.timer)
            return
          }
          startProgress = endProgress
          endProgress = intervals[currentIntervalIndex].targetProgress
        }

        const progressInPhase =
          (elapsedTime / duration) * (endProgress - startProgress)
        currentProgress = startProgress + progressInPhase

        this.progress = Math.min(Math.round(currentProgress), 99)
      }, 100)
    },
    stopProgress() {
      this.progress = 0
      clearInterval(this.timer)
      this.timer = null
    },
  },
}
</script>

<style scoped>
.generate-loading {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
  padding: 40px 16px 10px 16px;
  box-sizing: border-box;
}
.progress-container {
  width: 100%;
  position: relative;
}

.progress-bar {
  width: 100%;
  height: 16px;
  background-color: #f5f5f5;
  border-radius: 10px;
  overflow: hidden;
}

.progress-inner {
  height: 100%;
  background: linear-gradient(to right, #409eff, #66b1ff);
  transition: width 0.1s ease-in-out;
  position: relative;
}
.progress-label {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background: #409eff;
  color: white;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress-label::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #409eff;
}

.loading-text {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  font-weight: bold;
}
</style>
